import { render, staticRenderFns } from "./BaseValidationAlerts.vue?vue&type=template&id=446efd15&scoped=true"
import script from "./BaseValidationAlerts.vue?vue&type=script&lang=js"
export * from "./BaseValidationAlerts.vue?vue&type=script&lang=js"
import style0 from "./BaseValidationAlerts.vue?vue&type=style&index=0&id=446efd15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446efd15",
  null
  
)

export default component.exports